import React from "react";

import "./PageInfoLayout.scss";
import logo from "@/assets/logo.svg";

interface IPageInfoLayoutProps {
  children: React.ReactNode;
}

// A page that show the cantamus logo and a custom message
export default function PageInfoLayout(props: IPageInfoLayoutProps): JSX.Element {
  return (
    <div className="PageInfoLayout">
      <img className="logo" src={logo} alt="Logo" />
      <div className="hero">{props.children}</div>
    </div>
  );
}
